import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./plugins/vuetify-datetime-picker";
import "./plugins/vue-meta";
import "./plugins/vee-validate";
import "./plugins/vue-tostification";
import "@babel/polyfill";
import "./components/shared";
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
